<template>
    <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
        <z-page title="Butiran Dan Rekod Perkembangan Bulanan Ternakan">
          <div class="w-flex wrap smd-column" >
            <div class="mx2"></div>
            <div class="grow ">
              <div class="w-flex wrap smd-column" >
                <div class="grow xs4" style="line-height: 15px">
                   <table>
                    <tbody>
                        <tr class="row_data">
                            <td><b>ID Premis</b></td>
                            <td><b>:</b></td>
                            <td>{{data.premis}}</td>
                        </tr>

                        <tr class="row_data">
                            <td><b>No. Pendaftaran</b></td>
                            <td><b>:</b></td>
                            <td>{{data.pendaftaran}}</td>
                        </tr>
                        <tr class="row_data">
                            <td><b>ID/Nama Ternakan</b></td>
                            <td><b>:</b></td>
                            <td>{{data.ternakan}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="grow xs4" style="line-height: 15px">
                   <table>
                    <tbody>
                        <tr class="row_data">
                            <td><b>Jenis Ternakan</b></td>
                            <td><b>:</b></td>
                            <td>{{data.lkp_ternakan}}</td>
                        </tr>
                        <tr class="row_data">
                            <td><b>Baka</b></td>
                            <td><b>:</b></td>
                            <td>{{data.baka}}</td>
                        </tr>
                        <tr class="row_data">
                            <td><b>Jantina</b></td>
                            <td><b>:</b></td>
                            <td>{{data.jantina}}</td>
                        </tr>
                      </tbody>
                    </table>
                </div>

                <div class="grow xs4" style="line-height: 15px">
                     <table >
                      <tbody>
                        <tr class="row_data">
                           <td><b>Tarikh Lahir</b></td>
                           <td><b>:</b></td>
                           <td>{{ $zutil.dateformat(data.tarikh_lahir)}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Tempat Lahir</b></td>
                           <td><b>:</b></td>
                           <td>{{data.negeri}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Berat Lahir (Kg)</b></td>
                           <td><b>:</b></td>
                           <td>{{data.berat_lahir}}</td>
                        </tr>
                        </tbody>
                      </table>
                </div>

               
              </div>
            </div>
          </div>
          <br>
          <br>
          <div class="w-table-wrap" >
            <table class="w-table" color="light" >
              <thead>
                <tr>
                  <th class="w-table__header  text-left" width="1%">No</th>
                  <th class="w-table__header  text-left">Tarikh Timbang </th>
                  <th class="w-table__header  text-left">Umur (Hari)</th>
                  <!-- <th class="w-table__header  text-left">ID Premis/ Nama Premis</th> -->
                  <th class="w-table__header  text-left">Berat Semasa (Kg)</th>
                  <th class="w-table__header  text-left">Average Daily Gain (ADG)</th>
                  <th class="w-table__header  text-left">Kaedah Timbang</th>
                  <th class="w-table__header  text-left">Catatan</th>
                  <th class="w-table__header  text-left"  width="1%">
                     <w-button dark class="green--bg ml1" @click="add()">
                        <w-icon class="mr1">fal fa-plus</w-icon> 
                    </w-button>
                  </th>
                </tr>
              </thead>

              <tbody>
                <template v-if="data.ppt && data.ppt.length == 0">
                  <tr class="w-table__row" >
                    <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
                  </tr>
                </template>
                <template v-for="(dt, ind) in data.ppt">
                  <tr class="w-table__row" >
                    <td class="w-table__cell text-left" style="padding-top:10px">{{ind+1}}</td>
                    <td class="w-table__cell text-left" style="padding-top:10px">{{ $zutil.dateformat(dt.tarikh_timbang)}}</td>
                    <td class="w-table__cell text-left" style="padding-top:10px">{{ $zutil.umurHari(data.tarikh_lahir, dt.tarikh_timbang)}}</td>
                    <td class="w-table__cell text-left" style="padding-top:10px">{{dt.berat}}</td>
                    <td class="w-table__cell text-left" style="padding-top:10px">{{dt.adg}}</td>
                    <td class="w-table__cell text-left" style="padding-top:10px">{{dt.lkpKaedahTimbang}}</td>
                    <td class="w-table__cell text-left" style="padding-top:10px">{{dt.catatan}}</td>
                    <td class="w-table__cell text-left" >
                      <w-button class="fs-2 pr3 bs" bg-color="orange-light3" tile @click="edit(dt)" ><w-icon xs class="mr2">fal fa-pencil</w-icon> </w-button>
                    </td>
                    
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
         <GChart type="LineChart" :data="chartBerat"/>
         <GChart type="LineChart" :data="chartAdg" :options="chartOptions"/>
          <!-- <GChart type="LineChart" :data="chartData"/> -->
        </z-page>
        <w-dialog
        v-model="dialog.show"
        :fullscreen="dialog.fullscreen"
        :width="dialog.width"
        :persistent="dialog.persistent"
        :persistent-no-animation="dialog.persistentNoAnimation"
        title-class="primary-dark1--bg white">
        <template #title>
          <w-icon class="mr2">fal fa-cog</w-icon>
          Rekod Perkembangan Bulanan Ternakan
        </template>

        <w-form 
          ref="form" 
          v-model="dialog.valid"
          @validate="submit"
          @success="success"
        >

        <w-input 
           label="Tarikh Timbang *" 
           v-model="form.tarikh_timbang" 
           type="date" 
           name="tarikh_timbang" 
           :validators="[validators.required, validators.dateAfterBirth]"  
           @input="adg"
           :min="data.tarikh_lahir"
         />
        <w-input label="Berat (Kg) *" v-model="form.berat" type="number" step="0.01" name="berat" :validators="[validators.required]" @input="adg"/>
        <w-input label="Average Daily Gain (ADG)" v-model="form.adg" type="number" step="0.01" name="adg" readonly />
        <z-select :items="kaedah_timbang" label="Kaedah Timbang"  v-model="form.lkp_kaedah_timbang_id"></z-select>
        <z-input label="Catatan" v-model="form.catatan" name="Keterangan"  />
        </w-form>
            

        
        <template #actions>
          <div class="spacer" />
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
          <w-button 
          class="ml1" 
          :loading="dialog.loading"
          :disabled="dialog.valid === false"
          @click="$refs.form.validate()"
          >
            SIMPAN
          </w-button>
        </template>

        
      </w-dialog>
    </zen-one>
    
  </template>
  
  <script>
  import { reactive } from 'vue'
  import ZResource from '@/Modules/z-resource'
  import { GChart } from "vue-google-charts";

  export default {
    extends: ZResource,
    props: {
      id: [Array, Object, String],
    },
   components: {
        GChart
    },
    data() {
      return {
        resourceurl: 'ppt',
        crumbs: [
          { label: this.$page.props.app_name, route: '/home' },
          { label: 'Rekod Ternakan', route: '/art/ternakan' },
        ],
        data : {ppt:[]},
        kaedah_timbang : [],
        form: {
          id: 0,
          tarikh_timbang: '',
          berat: '',
          adg: '',
          catata : '',
          lkp_kaedah_timbang_id: '',
        },
        chartData: [
          ['Umur Hari','Berat Kg','ADG'],
        ],
        chartBerat: [
          ['Umur Hari','Berat Kg'],
        ],
        chartAdg: [
          ['Umur Hari','ADG'],
        ],
        chartOptions: {
          colors: ['red']
        }
      }
    },
    methods: {
      add(){
        this.form = {
          id: 0,
          art_anak_id : this.data.id,
          ternakan_id : this.data.ternakan_id,
          tarikh_timbang: new Date().toISOString().split('T')[0],
          berat: '',
          adg: '',
          catatan : '',
          lkp_kaedah_timbang_id: '',
        }
          
        this.dialog.show = true
        this.form.saveButton = "Simpan"
      },
     
      edit(item){
        this.form = item
        this.dialog.show = true
        this.form.saveButton = "Kemaskini"
      },
      adg(){
        var umur = this.$zutil.umurHari(this.data.tarikh_lahir, this.form.tarikh_timbang);
        var kenaikan = this.form.berat - this.data.berat_lahir;
        if(umur > 0){
           this.form.adg = (kenaikan / umur).toFixed(2)
        }
       
      },

      submit() {
        this.dialog.loading = true;

        this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            this.dialog.show = false;
            this.getData(); 
            this.$zutil.notify('Rekod berjaya disimpan.');
          })
          .catch(err => {
            if (err.response && err.response.status === 422) {
              this.$zutil.notify(err.response.data.message, false);
            } 
          })
          .finally(() => {
            this.dialog.loading = false;
          });
      },

      getData(){
        this.$zcomm.get(this.api_service + 'art/show-anak/'+this.id, {}).then(res => {
          this.data = res
          this.chartData= [ 
            ['Umur Hari','Berat Kg', 'ADG'],
            ['0 Hari', parseFloat(res.berat_lahir), 0],
          ];
          this.chartBerat= [ 
            ['Umur Hari','Berat Kg'],
            ['0 Hari', parseFloat(res.berat_lahir)],
          ];
          this.chartAdg= [ 
            ['Umur Hari', 'ADG'],
            ['0 Hari', 0],
          ];
          for(var i in res.ppt){
            this.chartData.push([
              this.$zutil.umurHari(res.tarikh_lahir, res.ppt[i].tarikh_timbang)+' Hari', 
              parseFloat(res.ppt[i].berat), 
              parseFloat(res.ppt[i].adg)
            ])
            this.chartBerat.push([
              this.$zutil.umurHari(res.tarikh_lahir, res.ppt[i].tarikh_timbang)+' Hari', 
              parseFloat(res.ppt[i].berat)
            ])
            this.chartAdg.push([
              this.$zutil.umurHari(res.tarikh_lahir, res.ppt[i].tarikh_timbang)+' Hari', 
              parseFloat(res.ppt[i].adg)
            ])
          }
          console.log(this.chartData)
        })
      },
      geKedahTimbang(){
        this.$zcomm.get(this.api_service + 'lookup/kaedah_timbang', {}).then(res => {
          this.kaedah_timbang = res
        })
      },
      
    
    },
  
    watch: {
  
    },
    mounted() {
      if (this.form.id == 0) {
      var today = new Date();
       this.form.tarikh_timbang = today.toISOString().split('T')[0];
    }
      this.getData();
      this.geKedahTimbang();
      
    },
  }
  </script>
  